export enum InvoiceType {
	BACKEND = 0,
	NORMAL = 1,
	QUOTATION = 2,
	PROVIDER = 3,
	TRANSFER = 4,
	INVENTORY = 5,
	NCRE = 6,
	FCAM = 7,
	ADVANCE = 8
}